var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlayVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.28 27.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    className: "cls-3",
    d: "m13.64,0C6.11,0,0,6.11,0,13.64s6.11,13.64,13.64,13.64,13.64-6.11,13.64-13.64S21.17,0,13.64,0h0Zm0,26.42C6.58,26.42.85,20.7.85,13.64S6.58.85,13.64.85s12.79,5.72,12.79,12.79h0c0,7.06-5.72,12.79-12.79,12.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    className: "cls-2",
    d: "m18.89,13.26l-8.1-4.04c-.21-.1-.47,0-.57.21-.03.05-.04.11-.04.17v8.08c0,.24.2.42.43.42.06,0,.12-.01.17-.04l8.1-4.04c.21-.11.3-.36.19-.57-.04-.08-.11-.15-.19-.19Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "m13.64,0C6.11,0,0,6.11,0,13.64s6.11,13.64,13.64,13.64,13.64-6.11,13.64-13.64S21.17,0,13.64,0h0Zm0,26.42C6.58,26.42.85,20.7.85,13.64S6.58.85,13.64.85s12.79,5.72,12.79,12.79h0c0,7.06-5.72,12.79-12.79,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "m18.89,13.26l-8.1-4.04c-.21-.1-.47,0-.57.21-.03.05-.04.11-.04.17v8.08c0,.24.2.42.43.42.06,0,.12-.01.17-.04l8.1-4.04c.21-.11.3-.36.19-.57-.04-.08-.11-.15-.19-.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 27.28,
    height: 27.28
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayVideo);
export default __webpack_public_path__ + "static/media/ic_play_video.8b74c1d3a505e335a4bb77929704a4e7.svg";
export { ForwardRef as ReactComponent };